<template>
  <div class="content-box">
	  <HconTitle subTitle="온라인 견적서" subDescription="구매 전 결제 금액을 확인하고, 견적서를 작성·관리하는 기능을 편리하게 이용하세요." />
    <div class="sub-wrapper block">
      <div class="box-gray pt29 p20 mb20 rounded20">
        <div class="contents-title-wrap">
          <div class="contents-title">
            <h3 class="mr15">상품 선택</h3>
            <div class="flex shrink0 mr6 gap8 al-c">
            <ClientOnly>
              <img v-show="userImgGrade" :src="userImgGrade" class="grade-img" width="25" alt=""/>
              <span class="font-bold">{{ userGrade.toUpperCase() }} 혜택가 적용 중 ·</span>
              <p class="text-gray font-bold mr8">유효기간 {{ expiryDate }}일</p>
              <button type="button" @click="showExpiryDateSelectionPopup()" class="btn btn-outline xs">유효기간 선택</button>
            </ClientOnly>
            </div>
          </div>
        </div>
        <div class="contents-detail-wrap">
          <div class="form-box">
            <div class="form-group row">
              <HconInput type="text" v-model="searchInp" label="입력서식컴포넌트" :hide-label="true" inputClass="md" :showButton="true" buttonText="조회" buttonClass="btn-gray md wd98" @buttonClick="handleSearchBtn" placeholder="상품명 또는 브랜드명으로 조회하세요" />
            </div>
          </div>
        </div>
        <div v-if="isSearchResult" class="contents-title-wrap mt32 mb13">
          <div class="contents-title">
            <h3 class="mr9 fs18">총 <span class="text-green">{{ searchSummary.brandCnt }}</span>개의 브랜드와 <span class="text-green">{{ searchSummary.productCnt }}</span>개의 상품이 검색되었습니다.</h3>
          </div>
          <div class="rgt-area">
            <button type="button" class="link reset fs15" @click="resetAll('search')">초기화</button>
          </div>
        </div>
        <div v-else class="contents-title-wrap mt32 mb13">
          <div class="contents-title">
            <h3 class="mr9 fs18">브랜드</h3>
            <p class="text-gray font-bold"><span class="text-green">{{ brandList.length }}</span>개</p>
          </div>
          <div class="rgt-area">
            <ul class="li-bar sort-list">
              <li v-for="(item, index) in sortList.brandSort" :key="index" class="fs14" :class="{ 'active': activeIds.brand === item.id}">
                <button type="button" class="sort-btn" @click="selectItem(item.id, 'brand')">{{ item.text }}</button>
              </li>
            </ul>
          </div>
        </div>        
        <div class="contents-detail-wrap">
          <div class="box-border scroll rounded12 list-box mx-hg280 hg280">
            <ul v-if="brandList.length > 0" class="brand-list">
              <li class="brand-item" :class="[{'all': item.id === 'all'},{ 'active': item.id === selectedBrandId }]" v-for="(item, index) in brandList" :key="index">
                <button type="button" @click="selectBrand(item)" class="brand-btn">
                  <span class="brand-thumb">
                    <img :src="item.src" width="80" height="50" :alt="`${item.alt}`" loading="lazy" />
                  </span>
                  <span class="brand-text">{{ item.text }}</span>
                </button>
              </li>
            </ul>
            <ul v-else class="nodata">
              <li>조회된 브랜드가 없습니다.</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="flex gap20">
        <div class="box-gray rounded20 w50p">
          <div class="contents-title-wrap mb16">
            <div class="contents-title">
              <h3 v-if="isSearchResult" class="mr9 fs18">총 상품</h3>
              <h3 v-else class="mr9 fs18">{{ selectBrandName?.text }}</h3>
              <p class="text-gray font-bold"><span class="text-green">{{ totalCount }}</span>개</p>
            </div>
            <div class="rgt-area">
              <ul class="li-bar sort-list">
                <li v-for="(item, index) in sortList.productSort" :key="index" class="fs14" :class="{ 'active': activeIds.product === item.id }">
                  <button type="button" class="sort-btn" @click="selectItem(item.id, 'product')">{{ item.text }}</button>
                </li>
              </ul>
            </div>
          </div>
          <div class="contents-detail-wrap">
            <div class="box-border scroll rounded12 list-box mx-hg846 hg846 pr6">
              <ul v-if="productList.length > 0" class="product-list">
                <li class="product-item" v-for="item in productList" :key="item.id">
                  <div class="product-item-box">
                    <div class="thumbnail">
                      <img class="thumb-img" :src="item.src" width="80" height="80" :alt="item.alt" loading="lazy">
                    </div>
                    <div class="product-info-box">
                      <p class="brand-name">{{ item.brandName }}</p>
                      <p class="product-name">{{ item.productName }}</p>
                      <ul class="amount-box li-bar">
                        <li>
                          <span class="percent">{{ HconCommonUtils.format.expComma(item.productPercent) }}%</span>
                          <span class="discount ml8">{{ HconCommonUtils.format.addWon(item.discountCharge) }}</span>
                          <span class="total ml8">{{ HconCommonUtils.format.addWon(item.total) }}</span>
                        </li>
                        <li>
                          <span class="limit-period">유효기간 {{ item.limitPeriod }}일</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <button type="button" class="btn-plus" @click="handleAlreadyAddProduct(item.id)"></button>
                </li>
              </ul>              
              <ul v-else class="nodata">
                <li>조회된 상품이 없습니다.</li>
              </ul>
              <!-- <div v-if="productList.length > 20" class="more-btn mt20"> -->

              <div v-if="isShowMoreButton" class="more-btn mt20">
                <button type="button" class="btn btn-outline sm text-lightgray" @click="loadMore()"><span class="text-black mr5">더보기 {{ productList.length }}</span>/ {{ totalCount }}</button>
              </div>
            </div>
          </div>
        </div>
        <div class="box-gray rounded20 w50p">
          <div class="form-group gap20 mb32">
            <HconInput type="text" v-model="estimateNmInp" ref="inputEstimateNmTextRef" label="견적서명" :hide-label="false" labelClass="fs20 font-bold" inputClass="md" :maxlength="20" placeholder="견적명을 입력해주세요 (최대 20자)" />
          </div>
          <div class="contents-title-wrap mb12">
            <div class="contents-title">
              <h3 class="mr9 fs18">견적 상품</h3>
              <p class="text-gray font-bold mr8 shrink0">총 <span class="text-green">{{ selectedProList.length }}</span>건</p>
              <p class="text-gray02">(최대 20건)</p>
            </div>
            <div class="rgt-area mr10 ml10 gap8">
              <button type="button" class="btn btn-outline xs" @click="showAddedGoodsImportPopup">담긴상품 불러오기 <strong class="font-bold text-green ml7">{{ addedGdsImprCnt }}</strong></button>
              <button type="button" class="btn btn-outline xs" @click="handleAllDeleteProduct">전체삭제</button>
            </div>
          </div>
          <div class="contents-detail-wrap">
            <div class="box-border scroll rounded12 list-box mx-hg725 hg725 pr6">
              <ul v-if="selectedProList.length > 0" class="product-list">
                <li class="product-item gap4" v-for="item in selectedProList" :key="item.id">
                  <div class="product-item-box">
                    <div class="thumbnail">
                      <img class="thumb-img" :src="item.src" width="80" height="80" :alt="item.alt" loading="lazy">
                    </div>
                    <div class="product-info-box">
                      <p class="brand-name">{{ item.brandName }}</p>
                      <p class="product-name">{{ item.productName }}</p>
                      <ul class="amount-box li-bar">
                        <li>
                          <span class="percent">{{ HconCommonUtils.format.expComma(item.productPercent) }}%</span>
                          <span class="discount ml8">{{ HconCommonUtils.format.expComma(item.discountCharge) }}원</span>
                          <span class="total ml8">{{ HconCommonUtils.format.expComma(item.total) }}원</span>
                        </li>
                        <li>
                          <span class="limit-period">유효기간 {{ item.limitPeriod }}일</span>
                        </li>
                      </ul>
                      <div class="pay-box mt15">
                        <button type="button" class="pay-btn" @mouseover="showTooltip($event)" @mouseout="hideTooltip($event)">
                          <span class="h-coin" :class="{ on: item.payments.hcoin}"></span>
                          <span class="p-coin" :class="{ on: item.payments.pcoin}"></span>
                          <span class="credit-card" :class="{ on: item.payments.card}"></span>
                          <span class="account" :class="{ on: item.payments.account}"></span>
                          <div class="pay-tooltip">
                            <div class="pay-tooltip-inner">
                              <p :class="{all: isAllPayment}">{{ paymentTooltipText(item) }}</p>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="count-box">
                    <HconInput type="count" v-model="item.inpCount" label="수량" :hide-label="true" inpWrapClass="wd96" inputClass="sm" :min="1" :max="10000" />
                  </div>
                  <button type="button" class="btn-minus shrink0" @click="handleDeleteProduct(item.id)"></button>
                </li>
              </ul>              
              <ul v-else class="nodata">
                <li>견적을 원하는 상품을 조회하여 담아주세요.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="mt40 mb20">
        <h3 class="fs20 font-bold">견적 금액 확인</h3>        
      </div>
      <div class="contents-detail-wrap">
        <div class="box-table">
          <ul class="col4 amount-list">
            <li>
              <div class="amount-box h100p">
                <p class="amount-flex">
                  <span class="title">총 견적수량</span>
                  <span class="total">{{ HconCommonUtils.format.expComma(totalQuantity) }}건</span>
                </p>
              </div>
            </li>
            <li>
              <div class="amount-box h100p">
                <p class="amount-flex">
                  <span class="title">총 상품금액</span>
                  <span class="total">{{ HconCommonUtils.format.expComma(totalOriginalAmount) }}원</span>
                </p>
              </div>
            </li>
            <li>
              <div class="amount-box h100p">
                <p class="amount-flex">
                  <span class="title">총 할인금액</span>
                  <span class="total">{{ HconCommonUtils.format.expComma(totalDiscountAmount) }}원</span>
                </p>
              </div>
            </li>
            <li class="wd350 shrink0">
              <p class="title mb27 text-green">총 견적금액</p>
              <p class="fs38 font-bold ta-r">
                <span class="text-green">{{ HconCommonUtils.format.expComma(totalPaymentAmount) }}</span>원
              </p>
            </li>
          </ul>
        </div>        
      </div>

      <div class="button-box mt40 gap8">
        <button type="button" class="btn btn-outline lg" @click="handleMQuoteMngPop">견적서 관리</button>
        <button type="button" class="btn btn-outline lg" @click="handleMakeQuotePop">견적서 작성</button>
        <div class="relative">
          <button type="button" class="btn lg tooltip-btn" @click="handleBuyQuotePop" :disabled="canPay">바로구매</button>
          <div class="tooltip">
            <p>선택하신 상품마다 결제수단이 달라 함께 주문할 수 없습니다.</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 유효기간선택 팝업 -->
  <HconPinPopupExpiryDateSelection v-model="expiryDate" @update:modelValue="resetAll" ref="popupExpiryDateSelectionRef" />

  <!-- 담긴상품불러오기 팝업 -->
  <HconAddedGoodsImport :flag=true @chk-gds="addSeletedProducts" @update-gdsCnt="val => addedGdsImprCnt = val" ref="popupAddedGoodsImportRef" />
  
  <!-- 견적서 작성 팝업 -->
  <HconEstimateWrite v-if="isEstimateWriteVisible && finalEstimateForm" ref="popupEstimateWriteRef" 
                              @close="isEstimateWriteVisible = false" />

  <!-- 비회원 견적서 입력 팝업 -->
  <HconEstimateGuestInput v-if="isEstimateGuestVisible" ref="popupEstimateGuestInputRef" @onSubmitGuestInfo="handleGuestSubmit"
                                  @close="isEstimateGuestVisible = false" />

</template>

<script lang="ts" setup>
import HconTitle from '@/components/com/HconComPCTitle.vue'
import HconInput from '@/components/com/HconComPCInputField.vue'
import HconPinPopupExpiryDateSelection from '@/components/popup/HconPinPopupExpiryDateSelection.vue'
import HconAddedGoodsImport from '@/components/popup/HconAddedGoodsImport.vue'
import HconEstimateWrite from '@/components/popup/HconEstimateWrite.vue'
import HconEstimateGuestInput from '@/components/popup/HconEstimateGuestInput.vue'

import { checkCommonPayment } from '~/utils/payment/payment-utils'
import { usePopup } from '@/composables/hconUsePopup'
import { ref, onMounted, toRaw } from 'vue'
import { useRouter } from 'vue-router'
import { COMMON_CODE, ORDER_CODE, ESTIMATE_CODE, MEMBER_CODE } from "@/constants/hconMessageConstants"
import type { BrandResDto, GoodsResDto, SearchResDto } from '~/types/coupon/backend-dto-types' // background dto
import type { QuotationAddResDto } from '~/types/estimate/backend-dto-types'

//////////////////////////////////////////////
// 초기 화면 로드 & 기본 세팅
//////////////////////////////////////////////

definePageMeta({label:'온라인 견적서', movable: false})
const { showAlert, showConfirm, openLoginPopup } = usePopup()
const fetchBuilder  = useHconFetchBuilder()
const router = useRouter() 
const expiryDate = ref('30') // 유효기간 세팅
const canPay = ref(false) // 선택상품 바로구매 버튼 제어
const totalCount = ref(0) // 상품리스트 값
const addedGdsImprCnt = ref(0) // 담긴상품 갯수

// 화면 마운트
onMounted(() => {
  getBrandList(1)
  getAddedGdsImprCnt()
})

//  공통 리셋/업데이트 함수
const updateSearch = (params: Partial<GoodsReq>) => {
  Object.assign(goodsReq, params)
}

// 초기화 공통 함수
const resetAll = (param?: string) => {
  
  if(param !== 'search') {
    selectedProList.value = []; // 선택상품 초기화
  }
  
  getBrandList(1)
}

// 더보기 버튼 노출 계산
const isShowMoreButton = computed(() => {
  if(totalCount.value === 0) {
    return false
  }

  return productList.value.length < totalCount.value
})

// S3 base URL
const s3BaseUrl = useRuntimeConfig().public.hcon.cdn.contentsBase; //'https://contents-oneday-dev.ezwelfare.net';

// 브랜드데이터 매핑
const transfromBrand = (item: any): BrandData => {

  const fileIdMatch = /^(([^\/]+)\/(\d{8})\/)?(([TPOC])(\d{6})[0-9a-fA-F]{32})$/.exec(item.brndLogoFilePath)
  let imgUrl
  if(fileIdMatch === null && item.brndLogoFilePath !== '') {
    imgUrl = s3BaseUrl + item.brndLogoFilePath;
  } else {
    imgUrl = cu.getFileFullUrl(item.brndLogoFilePath, true) // 추후 변경 필요 - 현재 경로로 파일이미지 로드 처리 - S3 로드로 변경 필요
  }

  return {
    id: item.hcBrndCd,
    // src: cu.getFileFullUrl(item.brndLogoFilePath, true), // 추후 변경 필요 - 현재 경로로 파일이미지 로드 처리 - S3 로드로 변경 필요
    src: imgUrl,
    alt: item.brndNm + ' 로고',
    text: item.brndNm
  }
}

// 상품데이터 매핑
const transfromProduct = (item: any): Product => {
  return {
    id: item.hcDspGdsCd+"_"+item.hcGdsCd,
    gdsCd: item.hcGdsCd,
    dspGdsCd: item.hcDspGdsCd,
    src: cu.getFileFullUrl(item.cpnTnailImgPath),
    alt: item.hcDspGdsNm,
    brandName: item.brndNm,
    productName: item.hcDspGdsNm,
    productPercent: item.dcRt,
    total: item.nrmlSellPrc,
    discountCharge: item.realSellPrc,
    limitPeriod: item.vlidTermDcnt,
    cshabGdsYn: item.cshabGdsYn, // 환금성상품여부
    crdPymtPossYn: item.crdPymtPossYn, // 카드결제가능여부
    acntTrnsPossYn: item.acntTrnsPossYn, // 계좌이체가능여부
    hcashPymtPossYn: item.hcashPymtPossYn, // H캐시결제가능여부
    mlgPymtPossYn: item.mlgPymtPossYn // 적립금결제가능여부
  }
}


//////////////////////////////////////////////
// 회원정보
//////////////////////////////////////////////

type UserGrade = 'friends' | 'gold' | 'platinum' | 'black';

const USER_GRADE_MAP: Record<string, string> = {
    '1000':	'friends'
  , '1010':	'gold'
  , '1020':	'platinum'
  , '1030':	'black'
}

interface UserData {
  imgGrade: string
  grade: UserGrade
}
const userKey = ref(useHconAuthInfo().getIfPossible()?.userContext.userKey)
const isLogin = computed(() => {
  return userKey.value !== undefined && userKey.value !== null && userKey.value !== ''
})

const defaultGrade = ref<UserGrade>(USER_GRADE_MAP['1000'] as UserGrade)
const myGrade = computed(() => {
  if(!isLogin.value) {
    return defaultGrade.value
  }
  const userGrade = useHconAuthInfo().getIfPossible()?.userContext.userGrade ?? '1000' as string;
  return defaultGrade.value = USER_GRADE_MAP[userGrade] as UserGrade
})

const gradeIcons = import.meta.glob('../../../../assets/images/pc/icon-hcon/grade-*.png', {eager: true, import: 'default'}) //페이지 경로가 바뀌는 경우 해당 부분도 수정
const getGradeIcon = (grade: string, hasText: boolean): string => {

  if(!grade) {
    return ''
  }
  
  const suffix = hasText ? '-text' : '',
        imgName = `grade-${grade.substring(0,1).toLocaleUpperCase()}`,
        path = `../../../../assets/images/pc/icon-hcon/${imgName}${suffix}.png`; //페이지 경로가 바뀌는 경우 해당 부분도 수정

  return (gradeIcons[path] as string) || '';
}

const userImgGrade = computed(() => getGradeIcon(myGrade.value, false))
const userGrade = computed(() => myGrade.value)

//////////////////////////////////////////////
// 견적서 관련 팝업
//////////////////////////////////////////////

// 유효기간선택 팝업
const popupExpiryDateSelectionRef = ref<InstanceType<typeof HconPinPopupExpiryDateSelection> | null>(null)
const showExpiryDateSelectionPopup = () => {
  popupExpiryDateSelectionRef.value?.handleOpen()
}

// 담긴상품불러오기 팝업
const popupAddedGoodsImportRef = ref<InstanceType<typeof HconAddedGoodsImport> | null>(null)
const showAddedGoodsImportPopup = () => {
  
  if(!isLogin.value) {
    showConfirm({
      title: "로그인 확인",
      message: MEMBER_CODE.ALT_HCON_9022,
      confirmText: "로그인하기",
      onConfirm: () => {
        openLoginPopup()
      }
    })
    return
  }

  popupAddedGoodsImportRef.value?.handleOpen()
}

// 견적서 작성 팝업
const popupEstimateWriteRef = ref<InstanceType<typeof HconEstimateWrite> | null>(null)
const showEstimateWritePopup = async () => {
  
  isEstimateWriteVisible.value = true
  
  await nextTick()
  if(isEstimateWriteVisible.value) {
    popupEstimateWriteRef.value?.handleOpen("WRITE", finalEstimateForm.value)
  }
}

// 비회원 견적서 입력 팝업
const popupEstimateGuestInputRef = ref<InstanceType<typeof HconEstimateGuestInput> | null>(null)
const showEstimateGuestInputPopup = async () => {
  
  isEstimateGuestVisible.value = true
  
  await nextTick()
  if(isEstimateGuestVisible.value) {
    popupEstimateGuestInputRef.value?.handleOpen()
  }
}


//////////////////////////////////////////////
// 브랜드
//////////////////////////////////////////////

// 정렬 데이터 타입 정의
interface BrandSortData {
  id: number
  text: string
  sortType: string
}
interface ProductSortData {
  id: number
  text: string
  sortType: string
}
interface SortData {
  brandSort: BrandSortData[]
  productSort: ProductSortData[]
}

// 정렬 데이터
const sortList = ref<SortData>({
  brandSort: [
    {id: 1, text: '인기순', sortType: 'popular'},
    {id: 2, text: '가나다순', sortType: 'name'}
  ],
  productSort: [
    {id: 1, text: '인기상품순', sortType: 'popular'},
    {id: 2, text: '할인율순', sortType: 'discount'},
    {id: 3, text: '낮은 가격순', sortType: 'lowPrice'},
    {id: 4, text: '높은 가격순', sortType: 'highPrice'}
  ]
})

// 정렬 선택 아이템 초기값
const activeIds = reactive({
  brand: sortList.value.brandSort?.[0].id ?? null,
  product: sortList.value.productSort?.[0].id ?? null
})

const selectItem = (id: number, type: 'brand' | 'product') => {
  activeIds[type] = id

  // sort값 선택에 따른 값 초기화&event 호출
  if(type === 'brand') {
    getBrandList(id)
  } else if(type === 'product') {
    const tmpSortType = sortList.value.productSort.find(item => item.id === id)
    if(tmpSortType !== undefined) {
      isSearchingWatchLock.value = true // watch 잠금
      updateSearch({
          sortType: tmpSortType?.sortType
        , pageNum: 1
        , isMore: false
      })
      getGoodsList(goodsReq)
    }
  }
}

// 브랜드 타입 정의
interface BrandData {
  id: string | number | 'all'
  src: string
  alt: string
  text: string
}

// 브랜드 리스트 아이템 초기값
const selectedBrandId: Ref<string | number | 'all' | null> = ref(1)

// 브랜드 리스트 데이터
const brandList = ref<BrandData[]>([])

// 상품조회요청 타입 정의
interface GoodsReq {
  hcBrndCd: string | number | 'all'
  vlidTermDcnt: string
  keyword: string
  sortType: string
  pageNum: number,
  pageSize: number,
  isMore: boolean,
  lginMndrYn: string 
}

// 상품조회요청 공통 오브젝트
const goodsReq = reactive<GoodsReq>({
  hcBrndCd: '',
  vlidTermDcnt: expiryDate.value,
  keyword: '',
  sortType: 'popular',
  pageNum: 1,
  pageSize: 20,
  isMore: false,
  lginMndrYn: 'N'
})

// 브랜드 목록 조회
const getBrandList = async (brandSort: number) => {

  // 값 초기화
  isSearchResult.value = false
  searchInp.value = ''
  const tmpSortType = sortList.value.brandSort.find(item => item.id === brandSort)

  if(tmpSortType == undefined) {
    showAlert({
      title: '알림',
      message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9160, '정렬유형'),
      confirmText: '확인'
    })
    return
  }

  const fetchBuilderResult = 
    fetchBuilder.get<AjaxResult<BrandResDto[]>>('/api/v1/coupon/pin-publication/brand/list')
      .query({
          vlidTermDcnt: expiryDate.value
        , sortType: tmpSortType.sortType
      })
      .build()
      .execute()
      .then(res => {
        if(res.resultCode != '200') {
          showAlert({
            title: '알림',
            message: res.resultMessage,
            confirmText: '확인'
          })
        } else {

          // 브랜드정보 세팅
          brandList.value = res.data.map(transfromBrand)

          if(brandList.value.length > 0) {
            // 선택된 브랜드 코드로 상품 리스트 조회 - 유효기간, 선택 브랜드
            Object.assign(goodsReq, {
                hcBrndCd: brandList.value[0].id 
              , vlidTermDcnt: expiryDate.value
              , keyword: ''
              , sortType: 'popular'
              , pageNum: 1
              , pageSize: 20
              , isMore: false
            })
            activeIds['brand'] = brandSort
            activeIds['product'] = 1
            selectedBrandId.value = brandList.value[0].id
          } else {
            productList.value = []
          }
        }
      })
    .catch(err => {
      showAlert(err.resultMessage)
      brandList.value = []
    })
}

// 브랜드 선택 active 추가 관련 스크립트
const selectBrand = (item: any) => {
  selectedBrandId.value = item.id

  let tmpId = item.id
  if(item.id === 'all') {
      tmpId = '' // 전체의 경우 '' 값 세팅
  }

  // 값 초기화
  updateSearch({
      hcBrndCd: tmpId
    , pageNum: 1
    , isMore: false
  })
}

// 선택 브랜드명 확인
const selectBrandName = computed(() => {
  return brandList.value.find(barnd => barnd.id === selectedBrandId.value)
})

let timer : ReturnType<typeof setTimeout> | null = null

// 상품조회요청 값 감시
watch(() => goodsReq, () => {

  if(isSearchingWatchLock.value) {
    return // 수동 검색 중일 때는 watch 잠금
  }

  if(timer) {
    clearTimeout(timer)
  }
  
  timer = setTimeout(() => {
    getGoodsList(goodsReq)
  }, 150)
  
}, { deep: true })


//////////////////////////////////////////////
// 상품
//////////////////////////////////////////////

// 상품 데이터 타입 정의
interface Product {
  id: number | string
  gdsCd : string
  dspGdsCd : string
  src: string
  alt: string
  brandName: string
  productName: string
  productPercent: number
  total: number
  discountCharge: number
  limitPeriod: number
  cshabGdsYn: string // 환금성상품여부
  crdPymtPossYn: string // 카드결제가능여부
  acntTrnsPossYn: string // 계좌이체가능여부
  hcashPymtPossYn: string // H캐시결제가능여부
  mlgPymtPossYn: string // 적립금결제가능여부
}

// 상품 리스트 데이터
const productList = ref<Product[]>([])

const getCleanParams = <T extends Record<string, any>>(obj: T) => {
  // 1. reactive 객체에서 순수 데이터만 추출
  const rawObj = toRaw(obj)

  // 2. 키/값 쌍을 순회하며 유효한 값만 필터링
  return Object.fromEntries(
    Object.entries(rawObj).filter(([_, value]) => {
      return value !== null && value !== undefined && value !== ''
    })
  )
}

// 상품 목록 조회
const getGoodsList = async (goodsReq: GoodsReq) => {

  const cleanParams = getCleanParams(goodsReq)

  const fetchBuilderResult = 
  fetchBuilder.get<AjaxResult<GoodsResDto[]>>('/api/v1/coupon/pin-publication/goods/list')
    .query(cleanParams)
    .build()
    .execute()
    .then((res: any) => {
        if(res.resultCode != '200') {
            showAlert({
              title: '알림',
              message: res.resultMessage,
              confirmText: '확인'
            })
            brandList.value = []
        } else {

          isSearchingWatchLock.value = false // watch 잠금해제

          // 상품정보 세팅
          if(goodsReq.isMore) {
            productList.value = [...productList.value, ... res.data.map(transfromProduct)]
          } else {
            productList.value = res.data.map(transfromProduct)
          }
          totalCount.value = res.total || 0
        }
    })
    .catch(err => {
      showAlert(err.resultMessage)
      brandList.value = []
      productList.value = []
    })
}

// 더보기 클릭 시
const loadMore = (): void => {
  updateSearch({
      pageNum: goodsReq.pageNum + 1
    , isMore: true
  })
}


//////////////////////////////////////////////
// 담긴상품 불러오기 갯수
//////////////////////////////////////////////

// 담긴상품 불러오기 갯수 조회
const getAddedGdsImprCnt = () => {
  
  if(!isLogin.value) {
    addedGdsImprCnt.value = 0
    return
  }

  const fetchBuilderResult = 
    fetchBuilder.get<AjaxResult<QuotationAddResDto>>('/api/v1/order/estimate/items/count')
      .build()
      .execute()
      .then((res: any) => {
          if(res.resultCode != '200') {
              showAlert({
                title: '알림',
                message: res.resultMessage,
                confirmText: '확인'
              })
          } else {
            // 담긴상품 갯수 세팅
            addedGdsImprCnt.value = res.data.qttnAddCnt
          }
      })
}

// 로그인 변화에 대한 대응
watch(isLogin, ()=> {
  getAddedGdsImprCnt()
})


//////////////////////////////////////////////
// 상품 선택&삭제
//////////////////////////////////////////////

// 선택 상품 타입 정의
interface SelectedProduct {
  id: number | string
  gdsCd : string
  dspGdsCd : string
  src: string
  alt: string
  brandName: string
  productName: string
  productPercent: number
  total: number
  discountCharge: number
  limitPeriod: number
  isCashable: boolean
  payments: PaymentMethods
  inpCount: string | number
  isSoldOut: boolean
  gdsAmt: number      // 상품금액 * 수량 (할인전 총액)
  gdsQttnAmt: number  // 할인가 * 수량 (실제 판매 총액)
  gdsDcAmt: number    // 총 할인금액
}

// 선택 상품안에 결제 가능 수단 타입 정의
interface PaymentMethods {
  hcoin: boolean
  pcoin: boolean
  card: boolean
  account: boolean
}

// 선택 상품 리스트
const selectedProList = ref<SelectedProduct[]>([])

// 상품 플러스 버튼 선택 시
const handleAlreadyAddProduct = (id: number | string) => {

  const isDuplicate = selectedProList.value.some(item => item.id === id)

  if(isDuplicate) {
    showAlert({
      title: '추가된 상품',
      message: ESTIMATE_CODE.ALT_HCON_9060,
      confirmText: '확인'
    })
    return
  }

  if(selectedProList.value.length >= 20) {
    showAlert({
      title: '상품 수량 확인',
      message: ESTIMATE_CODE.ALT_HCON_9123,
      confirmText: '확인'
    })
    return
  }

  const tmpSelectObj = productList.value.find(item => item.id === id)
  selectedProList.value = [...selectedProList.value, transfromSelectProduct(tmpSelectObj)]
  canPay.value = !checkCommonPayment(selectedProList.value)
}

// 선택 상품 데이터 매핑
const transfromSelectProduct = (item: any): SelectedProduct => {
  return {
    id: item.id,
    gdsCd: item.gdsCd,
    dspGdsCd: item.dspGdsCd,
    src: item.src,
    alt: item.brandName + " " + item.productName,
    brandName: item.brandName,
    productName: item.productName,
    productPercent: item.productPercent,
    total: item.total,
    discountCharge: item.discountCharge,
    limitPeriod: item.limitPeriod,
    isCashable: item.cshabGdsYn === 'Y' ? true : false, // 환금성 상품 여부
    inpCount: '1', // Default 1
    payments: {   hcoin: item.hcashPymtPossYn === 'Y' ? true : false
                , pcoin: item.mlgPymtPossYn === 'Y' ? true : false
                , card: item.crdPymtPossYn === 'Y' ? true : false
                , account: item.acntTrnsPossYn === 'Y' ? true : false },
    isSoldOut: item.buyPossYn === 'Y' ? false : true,
    gdsAmt: 0,      // 상품금액 * 수량 (할인전 총액)
    gdsQttnAmt: 0,  // 할인가 * 수량 (실제 판매 총액)
    gdsDcAmt: 0    // 총 할인금액
  }
}

// 선택 상품 마이너스 버튼 선택 시
const handleDeleteProduct = async (id: number | string) => {
  const confirmResult = showRemoveConfirm(); // 컨펌 팝업
  if( await confirmResult) {
    selectedProList.value = selectedProList.value.filter(item => item.id !== id)
    canPay.value = !checkCommonPayment(selectedProList.value)
  }
}

// 선택 상품 전체 삭제 버튼 선택 시
const handleAllDeleteProduct = async () => {
  
  if(selectedProList.value.length === 0) {
    showAlert({
      title: '선택 상품 없음',
      message: ORDER_CODE.ALT_HCON_9126,
      confirmText: '확인',
    })
    return
  }

  const confirmResult = showRemoveConfirm(); // 컨펌 팝업
  if( await confirmResult ) {
    selectedProList.value = []
  }
}

// 상품 삭제 전 컨펌 팝업
const showRemoveConfirm = async() => {
  const result = await showConfirm({
    title: '선택 상품 삭제',
    message: ESTIMATE_CODE.ALT_HCON_9061,
    confirmText: '확인',
    cancelText: '취소'
  })
  return result;
}

// 결제 가능 수단
const isAllPayment = (item: any) => {
    const p = item?.payments
    if (!p) return false

    return p.hcoin && p.pcoin && p.card && p.account
}

// 결제 가능 수단 툴팁
const paymentTooltipText = (item: any) => {
    if (!item.payments) return "결제 정보를 찾을 수 없습니다."

    const p = item.payments

    const availabel: string[] = []

    if (p.hcoin) availabel.push("H캐시")
    if (p.pcoin) availabel.push("적립금")
    if (p.card) availabel.push("카드")
    if (p.account) availabel.push("현금")

    if (availabel.length === 0 ) return "가능한 결재 수단이 없습니다"

    return availabel.length === 4 ? "모든 결제수단으로 구매가 가능합니다." : `이 상품은 ${availabel.join('·')}으로만 구매할 수 있습니다.`
}

// 결제 가능 수단 툴팁 보이기(좌표값 체크하여 스타일 넣기)
const showTooltip = (event: MouseEvent): void => {
    const trigger = event.currentTarget as HTMLElement
    const tooltip = trigger.querySelector('.pay-tooltip') as HTMLElement | null
    if (!tooltip) return

    const rect = trigger.getBoundingClientRect()

    tooltip.style.left = rect.left + (rect.width / 2) + 'px'
    tooltip.style.top = rect.top + 'px'
    tooltip.style.display = 'block'
}

// 결제 가능 수단 툴팁 숨기기
const hideTooltip = (event: MouseEvent): void => {
    const target = event.currentTarget as HTMLElement
    const tooltip = target.querySelector('.pay-tooltip') as HTMLElement | null
    if (tooltip) tooltip.style.display = 'none'
}


//////////////////////////////////////////////
// 팝업 상품 선택
//////////////////////////////////////////////

const addSeletedProducts = (newItems: any[]) => {

  // 선택여부체크
  if(newItems.length === 0) {
    showAlert({
      title: '등록 상품 선택',
      message: ESTIMATE_CODE.ALT_HCON_9063,
      confirmText: '확인'
    })
    return
  }

  // 품절여부 체크
  const chkSoldout = newItems.some((item) => item.isSoldOut === true)
  if(chkSoldout) {
    popupAddedGoodsImportRef.value?.openAlert()
    popupAddedGoodsImportRef.value?.onTransitionEnd_chkSoldout()
    return
  }

  // 중복체크
  const currentIds = selectedProList.value.map(item => item.id)
  const isDuplicate = newItems.some(item => currentIds.includes(item.id))
  if(isDuplicate) {
    showAlert({
      title: '추가된 상품',
      message: ESTIMATE_CODE.ALT_HCON_9060,
      confirmText: '확인'
    })
    return
  }

  // 최대 수량 체크 - (기존 + 새상품 중복 제외)
  if(selectedProList.value.length + newItems.length > 20) {
    showAlert({
      title: '상품 수량 확인',
      message: ESTIMATE_CODE.ALT_HCON_9123,
      confirmText: '확인'
    })
    return
  }
  
  // 유효기간체크 - 같은 유효기간 범위만 선택 가능
  let isValid = true
  newItems.forEach((item) => {
    const chkRange = getValidRange(item.limitPeriod)
    if(chkRange !== Number(expiryDate.value)) {
      isValid = false
    }
  })
  
  if(!isValid) {
    showAlert({
      title: '알림',
      message: ESTIMATE_CODE.ALT_HCON_9190,
      confirmText: '확인'
    })
    return
  }

  showConfirm({
    title: '선택 상품 추가',
    message: ESTIMATE_CODE.ALT_HCON_9064,
    confirmText: '확인',
    onConfirm: () => {
      selectedProList.value = [...selectedProList.value, ...newItems]
      canPay.value = !checkCommonPayment(selectedProList.value)

      // 팝업 닫기
      popupAddedGoodsImportRef.value?.handleClose()
    }
  })
}

// 유효기간 범위
const getValidRange = (selectedPeriod: number | string): number => {
  const period = Number(selectedPeriod)
  if(period >= 58 && period <= 62) return 60
  if(period >= 89 && period <= 92) return 90
  return 30
}


//////////////////////////////////////////////
// 결제금액 계산
//////////////////////////////////////////////

// 총 수량
const totalQuantity = computed(() => {
  return selectedProList.value.reduce((sum, item) => sum + Number((item.inpCount || 0)), 0)
})

// 총 금액
const totalOriginalAmount = computed(() => {
  return selectedProList.value.reduce((sum, item) => sum + (item.total * Number(item.inpCount)), 0)
})

// 최종 결제금액
const totalPaymentAmount = computed(() => {
  return selectedProList.value.reduce((sum, item) => sum + (item.discountCharge * Number(item.inpCount)), 0)
})

// 환금성상품 합계금액
const totalCashableAmount = computed(() => {
  return selectedProList.value.reduce((sum, item) => sum + ( item.isCashable === true ? item.discountCharge * Number(item.inpCount) : 0), 0)
})

// 총 할인금액
const totalDiscountAmount = computed(() => {
  return totalOriginalAmount.value - totalPaymentAmount.value
})


//////////////////////////////////////////////
// 조회 - 상품명/브랜드명
//////////////////////////////////////////////

const isSearchResult = ref() // 조회여부에 따른 타이틀 영역 상태값
const searchInp = ref('') // 조회 input
const estimateNmInp = ref('') // 견적서명 input
const isSearchingWatchLock = ref(false) // watch 잠금 관련
const searchSummary = ref({
    brandCnt: 0
  , productCnt: 0
})

// 상품 조회
const handleSearchBtn = (): void => {

  var isValid = searchInp.value === null 
                  || searchInp.value === undefined || String(searchInp.value).trim() === ''

  if(isValid) {
    showAlert({
      title: '알림',
      message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9174, ""),
      confirmText: '확인'
    })
    return
  }

  if(String(searchInp.value).trim().length < 2) {
    showAlert({
      title: '알림',
      message: COMMON_CODE.ALT_HCON_9175,
      confirmText: '확인'
    })
    return
  }

  isSearchingWatchLock.value = true // watch 잠금
  totalCount.value = 0

  updateSearch({
      keyword: searchInp.value
    , hcBrndCd: ''
    , pageNum: 1
    , isMore: false
  })

  const fetchBuilderResult = 
    fetchBuilder.get<AjaxResult<SearchResDto>>('/api/v1/coupon/pin-publication/search')
      .query(goodsReq)
      .build()
      .execute()
      .then((res: any) => {
        if(res.resultCode != '200') {
          showAlert({
            title: '알림',
            message: res.resultMessage,
            confirmText: '확인'
          })
        } else {
          isSearchingWatchLock.value = false // watch 잠금해제
          isSearchResult.value = true // 정상 조회
          brandList.value = res.data.brandList?.map(transfromBrand) || [] // 브랜드정보 세팅
          productList.value = res.data.productList.map(transfromProduct) // 상품정보 세팅

          if(brandList.value.length > 0) {
            selectedBrandId.value = 'all'
            searchSummary.value.brandCnt = Math.max(0, brandList.value.length - 1)
            searchSummary.value.productCnt = productList.value.length
            totalCount.value = res.total || 0
          } else {
            selectedBrandId.value = null
            searchSummary.value.brandCnt = 0
            searchSummary.value.productCnt = 0
            totalCount.value = res.total || 0      
          }
        }
    })
}


//////////////////////////////////////////////
// 견적서 관리
//////////////////////////////////////////////

// 견적서 관리 버튼 선택 시
const handleMQuoteMngPop = () => {

  if(!isLogin.value){
    showConfirm({
      title: "로그인 확인",
      message: MEMBER_CODE.ALT_HCON_9022,
      confirmText: "로그인하기",
      onConfirm: () => {
        openLoginPopup()
      }
    })
    return
  }

  // 견적서 관리 이동
  router.push({
    path: '/pc/order/estimate/list',
    // state: { }
  }) 
}


//////////////////////////////////////////////
// 견적서 작성
//////////////////////////////////////////////

const inputEstimateNmTextRef = ref<InstanceType<typeof HconInput> | null>(null)
const isEstimateWriteVisible = ref(false)
const isEstimateGuestVisible = ref(false)
const guestInfo = ref({ 
    companyName: ''
  , managerName: ''
})

interface EstimateForm {
  companyName: string
  managerName: string
  estimateName: string
  qttnNo: string
  estimateCrtDtKor: string
  estimateCrtDt: string
  totalQuantity: number
  totalOriginalAmt: number
  totalDiscountAmt: number
  totalPaymentAmt: number
  totalCashableAmt: number
  selectedProducts: SelectedProduct[]
}

const finalEstimateForm = ref<EstimateForm>({
    companyName: ''
  , managerName: ''
  , estimateName: ''
  , qttnNo: ''
  , estimateCrtDtKor: ''
  , estimateCrtDt: ''
  , totalQuantity: 0
  , totalOriginalAmt: 0
  , totalDiscountAmt: 0
  , totalPaymentAmt: 0
  , totalCashableAmt: 0
  , selectedProducts: []
})

// 견적서 작성 버튼 선택 시
const handleMakeQuotePop = () => {

  if(selectedProList.value.length === 0) {
    showAlert({
      title: '견적 상품 없음',
      message: ESTIMATE_CODE.ALT_HCON_9062,
      confirmText: '확인'
    })
    return
  }

  // 견적서명 체크
  if(estimateNmInp.value.length === 0 || String(estimateNmInp.value).trim() === '') {
    showAlert({
      title: '알림',
      message: ESTIMATE_CODE.ALT_HCON_9187,
      confirmText: '확인',
      onConfirm: () => {
        if(inputEstimateNmTextRef.value) {
          inputEstimateNmTextRef.value.onInputTextFocus();
        }
      }
    })
    return
  }

  // 로그인 체크
  if(!isLogin.value) {
    showEstimateGuestInputPopup() // 비로그인 팝업
    return
  }
  
  openEstimateWrite(null)
  showEstimateWritePopup() // 견적서 작성 팝업 호출
}

// 비회원 팝업 전달 값
const handleGuestSubmit = (data: {companyName: string, managerName: string}) => {
  
  guestInfo.value = data // 전달값 
  popupEstimateGuestInputRef.value?.handleClose() // 팝업 닫기
  
  openEstimateWrite(guestInfo.value)
  showEstimateWritePopup() // 견적서 작성 팝업 호출
}

// 견적서 작성 객체 생성
const openEstimateWrite = (guestData: { companyName: string, managerName: string} | null) => {

  // formData
  const finalForm = {
      companyName: guestData ? guestData.companyName : useHconAuthInfo().getIfPossible()?.userContext.bzcoNm || '없음'
    , managerName: guestData ? guestData.managerName : useHconAuthInfo().getIfPossible()?.userContext.name || '없음'
    , estimateName: estimateNmInp.value
    , qttnNo: ''
    , estimateCrtDtKor: ''
    , estimateCrtDt: ''
    , totalQuantity: totalQuantity.value
    , totalOriginalAmt: totalOriginalAmount.value
    , totalDiscountAmt: totalDiscountAmount.value
    , totalPaymentAmt: totalPaymentAmount.value
    , totalCashableAmt: totalCashableAmount.value
    , selectedProducts: selectedProList.value
  }

  finalEstimateForm.value = finalForm
}


//////////////////////////////////////////////
// 바로구매
//////////////////////////////////////////////

let gdsList: {}[] = []  // 상품리스트

// 상품리스트 세팅
const chkGdsList = (selectedProList: any) => {
  
  gdsList = selectedProList.map((item: any) => ({
    hcDspGdsCd: item.dspGdsCd,
    hcGdsCd: item.gdsCd
  }))

  return gdsList
}

// 바로구매 버튼 선택 시
const handleBuyQuotePop = async () => {

  if(!isLogin.value){
    showConfirm({
      title: "로그인 확인",
      message: MEMBER_CODE.ALT_HCON_9022,
      confirmText: "로그인하기",
      onConfirm: () => {
        openLoginPopup()
      }
    })
    return
  }
  
  if(selectedProList.value.length === 0) {
    showAlert({
      title: '견적 상품 없음',
      message: ESTIMATE_CODE.ALT_HCON_9062,
      confirmText: '확인'
    })
    return
  }

  // 상품 상태 체크
  const chkResult = await chkStatusGds("") as {res: boolean}
  
  if(chkResult.res) {

    chkGdsList(selectedProList.value) // 상품리스트 세팅

    // 바로구매 > 주문서 이동
    router.push({
      path: '/pc/order/application-form',
      state: {
        prevPage: 'E',
        gdsList: JSON.parse(JSON.stringify(gdsList as string[]))
      }
    }) 
  }
}

// 상품 상태 체크
const chkStatusGds = async (item: any) => {

  // 파라미터 확인
  let finalBskNoList: String[] = [] // 배열 초기화

  return new Promise(async (resolve) => {

    // 2. 환금성상품 체크
    const chkCshabGds = selectedProList.value.filter(target => 
      target.isCashable === true
    )

    if(chkCshabGds.length > 0) {

      // API 호출
      const response = await fetchBuilder.get<AjaxResult<any>>('/api/v1/order/check-trading-time')
        .progressMessage("잠시만 기다려주세요...")
        .build()
        .execute()

        if(response.resultCode != '200') {
          showAlert(response.resultMessage)
          resolve({res: false})
          return 
        } else {
          if(response.data.message === 'SUCESS') {
            const resultConfirm = await showCshabGdsInclConfirm()
            if (!resultConfirm) { 
              resolve({res: false})
              return
            } else if ("etc" === resultConfirm) {
              resolve({res: false})
              return 
            }
          } else { // 주문 불가인 경우
            showAlert({
              title: '알림',
              message: ORDER_CODE.ALT_HCON_9218,
              confirmText: '확인'
            })
            resolve({res: false})
            return 
          }
        }
    }

    resolve({res: true})
  })
}

// 환금성상품포함 시, 확인안내 팝업
const showCshabGdsInclConfirm = async () => {
  const message = ORDER_CODE.ALT_HCON_9120
  const result = await showConfirm({
    title: '구매 전 확인사항',
    message: message,
    confirmText: '확인완료',
    etcText: '1:1 문의',
    showEtcButton: true,
    showCancelButton: false,
    onEtc: () => {
      router.push({
        path: '/pc/inquiry/list'
        // state: {}
      })
    }
  })
  return result;
}

</script>

<style lang="scss" scoped>
  @use "@/assets/scss/pc/pin-hcon.scss" as *;
  @use "@/assets/scss/pc/order-hcon.scss" as *;
</style>